import React, { useRef } from "react"
// import VanillaTilt from "vanilla-tilt"

export const TiltCard = ({ as, children, ...props }) => {
  const ref = useRef(null)
  // TODO: придумать и реализовать ховер по картинкам - tilt глючит в сафари и не очень вяжется с дизайном сайта
  // useEffect(() => {
  //   VanillaTilt.init(ref.current, {
  //     max: 5,
  //     perspective: 1000,
  //     speed: 5000,
  //     glare: true,
  //     "max-glare": 0.6,
  //     gyroscope: false,
  //   })
  // }, [])

  const Component = as || "div"

  return (
    <Component ref={ref} {...props}>
      {children}
    </Component>
  )
}
